import BaseController from "confinus_ui/base_controller";

export default class BidItemRowController extends BaseController {
  static targets = ["quantity", "proposedPrice", "lineTotal", "deviation"];

  declare quantityTarget: HTMLInputElement;
  declare proposedPriceTarget: HTMLInputElement;
  declare lineTotalTarget: HTMLElement;
  declare deviationTarget: HTMLElement;
  declare hasQuantityTarget: boolean;
  declare hasProposedPriceTarget: boolean;
  declare hasLineTotalTarget: boolean;
  declare hasDeviationTarget: boolean;

  static values = {
    catalogPrice: { type: Number, default: 0 },
    maxDeviation: { type: Number, default: 0 },
    currencyCode: { type: String, default: "USD" },
  };

  declare catalogPriceValue: number;
  declare maxDeviationValue: number;
  declare currencyCodeValue: string;

  recalculate() {
    if (!this.hasQuantityTarget || !this.hasProposedPriceTarget) return;

    const qty = parseFloat(this.quantityTarget.value) || 0;
    const proposedDollars = parseFloat(this.proposedPriceTarget.value) || 0;
    const proposedCents = Math.round(proposedDollars * 100);
    const lineTotal = qty * proposedCents;

    if (this.hasLineTotalTarget) {
      this.lineTotalTarget.textContent = this.formatCurrency(lineTotal);
    }

    if (this.hasDeviationTarget && this.catalogPriceValue > 0) {
      const deviationPct =
        ((proposedCents - this.catalogPriceValue) / this.catalogPriceValue) *
        100;
      const roundedDev = Math.round(deviationPct * 10) / 10;

      if (roundedDev === 0) {
        this.deviationTarget.textContent = "—";
        this.deviationTarget.className = "text-gray-400";
        this.element.classList.remove("bg-red-50");
      } else {
        const sign = roundedDev > 0 ? "+" : "";
        this.deviationTarget.textContent = `${sign}${roundedDev.toFixed(1)}%`;

        const exceedsMax =
          this.maxDeviationValue > 0 &&
          Math.abs(roundedDev) > this.maxDeviationValue;

        if (exceedsMax) {
          this.deviationTarget.className = "text-red-600 font-semibold";
          this.element.classList.add("bg-red-50");
        } else if (roundedDev < 0) {
          this.deviationTarget.className = "text-green-600";
          this.element.classList.remove("bg-red-50");
        } else {
          this.deviationTarget.className = "text-amber-600";
          this.element.classList.remove("bg-red-50");
        }
      }
    }

    this.dispatch("price-change", { bubbles: true });
  }

  private formatCurrency(cents: number): string {
    const dollars = cents / 100;
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: this.currencyCodeValue,
    }).format(dollars);
  }
}
